/**
 * Overlay back-stack.
 *
 * The Android hardware back button (and iOS edge-swipe expectations) should
 * dismiss an open overlay — side drawer, notification panel, bottom sheet —
 * before navigating the router or exiting the app. Overlays register a close
 * callback while open; the native back handler (initNative.js) pops the most
 * recently opened one.
 *
 * Pure module state, no React dependency, so any component can register via a
 * one-line useEffect.
 */
const stack = [];

/**
 * Register an open overlay's close handler. Returns an unregister function —
 * call it when the overlay closes (or on unmount).
 */
export function pushOverlay(close) {
  const entry = { close };
  stack.push(entry);
  return () => {
    const i = stack.indexOf(entry);
    if (i !== -1) stack.splice(i, 1);
  };
}

/** True if any overlay is currently open. */
export function hasOverlay() {
  return stack.length > 0;
}

/**
 * Close the most-recently-opened overlay. Returns true if one was closed
 * (i.e. the back press was consumed), false if there was nothing to close.
 */
export function closeTopOverlay() {
  const entry = stack.pop();
  if (!entry) return false;
  try { entry.close(); } catch { /* ignore */ }
  return true;
}
